module.exports = __webpack_public_path__ + "img/tip5.97b2af07.png";